import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeDropper } from "@fortawesome/free-solid-svg-icons";
import { Card } from "react-bootstrap";
import TablaAntihomotoxicos from "./TablaAntihomotoxicos";

const Antihomotoxicos = () => {
  return (
    <Card>
      <Card.Header
        style={{
          backgroundColor: "#F5E6D3",
          color: "#5E8C5A",
          fontWeight: "bold",
        }}
        as="h3"
      >
        Bioregulación <FontAwesomeIcon icon={faEyeDropper} />
      </Card.Header>
      <Card.Body>
        <TablaAntihomotoxicos />
      </Card.Body>
    </Card>
  );
};

export default Antihomotoxicos;
